import { lazy } from "react";

export const CourseModulesInput = lazy(() => import("./CourseModulesInput_"));
